function About(){
    return (
        <div>
          <h2>About page</h2>
        </div>
      );
}
export default About;